import React, { useState, useEffect } from "react";
import axios from "axios";
import * as constants from "../constants";
import parse from "html-react-parser";
import { useParams } from "react-router-dom";
import { removeDecimalIfZero } from "../services/helperFunction";
import { toast } from "react-toastify";
import moment from "moment/moment";
import Icon from "./icons/Icon";
import AccountSummary from "./AccountSummary";

const ProgramFee = () => {
  const [transactions, setTransactions] = useState(undefined);
  const [financialSummary, setFinancialSummary] = useState(undefined);
  const [loadingSummary, setLoadingSummary] = useState(true);
  const [loadingTransactions, setLoadingTransactions] = useState(true);
  const [error, setError] = useState(false);
  let { id } = useParams();

  const renderStatus = (cancelled, isOverDue, type, isPaid, transactionNo) => {
    if (type === "Invoice" && !transactionNo.startsWith("-")) {
      if (cancelled === "1") {
        return (
          <span className="font-medium inline-block px-1 text-xs rounded-full text-red-800 bg-red-100">
            Cancelled
          </span>
        );
      } else {
        if (isOverDue === "1") {
          return (
            <span className="font-medium inline-block px-1 text-xs rounded-full text-white bg-red-500">
              Overdue
            </span>
          );
        } else {
          if(isPaid === "1"){
            return (
              <span className="font-medium inline-block px-1 text-xs rounded-full text-sky-600 bg-sky-100">
                Paid
              </span>
            );  
          }else{
            return (
              <span className="font-medium inline-block px-1 text-xs rounded-full text-green-800 bg-green-100">
                Active
              </span>
            );
          }
        }
      }
    }
  };

  const filters = [
    { key: "all", label: "All" },
    { key: "invoice", label: "Invoices" },
    { key: "payment", label: "Payments" },     // Receipt
    { key: "transfer", label: "Transfers" },   // Transfer
    { key: "refund", label: "Refunds" },       // Refund (optional)
  ];

  const [activeFilter, setActiveFilter] = useState("all");

  const filteredTransactions = (transactions || []).filter((t) => {
    const type = (t.transactionType || "").toLowerCase();
    const isInvoice = type === "invoice" && !t.transactionNo?.startsWith("-");
    const isCreditNote = type === "invoice" && t.transactionNo?.startsWith("-");

    switch (activeFilter) {
      case "invoice":
        return isInvoice || isCreditNote; // include both; change if you want only invoices
      case "payment":
        return type === "receipt";
      case "transfer":
        return type === "transfer";
      case "refund":
        return type === "refund";
      default:
        return true;
    }
  });


  const renderDue = (transaction) => {

    const { transactionType, transactionNo, cancelled, dueInDays, dueDate } = transaction;

    const isInvoice = transactionType.toLowerCase() === "invoice" && !transactionNo.startsWith("-");
    const isCancelled = parseInt(cancelled);
    const isDueDateFuture = moment(dueDate).isAfter(moment());
    const dueDays = parseInt(dueInDays);

    if(!isInvoice || isCancelled || isDueDateFuture ){
      return ""
    }

    if(dueDays === 0){
      return "Due Today"
    }

    if(dueDays < 0){
      return `Due ${dueDays * -1} days ago`
    }
  }

    useEffect(() => {
    const fetchData = async () => {
      setLoadingSummary(true);
      setLoadingTransactions(true);
      
      try {
        const financialSummaryResponse = await axios.get(
          constants.BASEURL + "Student/FinancialsSummary/" + id
        );
        
        if (financialSummaryResponse.data.length > 0) {
          setFinancialSummary(financialSummaryResponse.data[0]);
        }
        setLoadingSummary(false);
        
        const transactionsResponse = await axios.get(
          constants.BASEURL + "Student/Financials/" + id
        );
        
        setTransactions(transactionsResponse.data);
        setLoadingTransactions(false);
        
      } catch (error) {
        setError(true);
        toast.error("Something went wrong");
        setLoadingSummary(false);
        setLoadingTransactions(false);
      }
    };

    fetchData();  
  }, [id]);

  // if (!transactions) return "vishas...";
  if (error) return "Something went wrong";

  // const columns = [
  //   {
  //     title: <span className="text-gray-500">Description</span>,
  //     dataIndex: "description",
  //     key: "description",
  //   },
  //   {
  //     title: <span className="text-gray-500">Date</span>,
  //     dataIndex: "date",
  //     key: "date",
  //   },
  //   {
  //     title: <span className="text-gray-500">Debit</span>,
  //     dataIndex: "debit",
  //     key: "debit",
  //     align: "right",
  //   },
  //   {
  //     title: <span className="text-gray-500">Credit</span>,
  //     dataIndex: "credit",
  //     key: "credit",
  //     align: "right",
  //   },
  //   {
  //     title: <span className="text-gray-500">Balance</span>,
  //     dataIndex: "balance",
  //     key: "balance",
  //     align: "right",
  //     render: (text) => {
  //       return (
  //         <>
  //           <p style={{ color: "black" }}> {text}</p>
  //         </>
  //       );
  //     },
  //   },
  // ];

  // const dataSource = transactions.map((transaction) => ({
    
  //   key: transaction?.transactionNo,
  //   description: (
  //     <div>
  //       <div className="description">
  //         <div className="icon">
  //           <div
  //             className={`iconContent ${
  //               transaction.transactionType === "Receipt"
  //                 ? "receipt"
  //                 : transaction.transactionType === "Refund"
  //                 ? "refund"
  //                 : transaction.transactionType === "Transfer"
  //                 ? "transfer"
  //                 : transaction.transactionNo.startsWith("-")
  //                 ? "negative"
  //                 : ""
  //             } `}
  //           >
  //             {transaction.transactionNo.startsWith("-") ? (
  //               <p>CN</p>
  //             ) : (
  //               transaction.transactionType.substring(0, 3)
  //             )}
  //           </div>
  //         </div>
  //         <div className="info text-gray-900">
  //           <div className="title">
  //             {transaction.transactionType +
  //               "# " +
  //               transaction.transactionNo +
  //               " "}
  //             {renderStatus(
  //               transaction.cancelled,
  //               transaction.isOverDue,
  //               transaction.transactionType
  //             )}
  //           </div>
  //           <div className="subtitle text-gray-500">
  //             {"created on " + transaction.createDate}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ),
  //   date: (
  //     <div>
  //       <div className="date text-gray-900 ">
  //         {transaction.transactionType +
  //           " Date: " +
  //           transaction.transactionDate}
  //       </div>
  //       <div className="subtitle text-gray-500 ">
  //         {transaction.dueDate ? <p>Due Date: {transaction.dueDate}</p> : ""}
  //         {parseInt(transaction.dueInDays) === 0 ? (
  //           <p>Due Today</p>
  //         ) : parseInt(transaction.dueInDays) > 0 &&
  //           parseInt(transaction.dueInDays) < 30 ? (
  //           <p>Due in {transaction.dueInDays} days</p>
  //         ) : (
  //           ""
  //         )}
  //       </div>
  //     </div>
  //   ),
  //   debit: removeDecimalIfZero(transaction.debit),
  //   credit: removeDecimalIfZero(transaction.credit),
  //   balance: removeDecimalIfZero(transaction.balance),
  // }));
  // console.log(dataSource)

    const getTransactionIcon = (transactionType, transactionNo) => {
      const isNegativeInvoice = transactionType === "Invoice" && transactionNo?.startsWith("-");
    const iconMap = {
      Invoice: <Icon name="invoiceIcon" size={6}  className={isNegativeInvoice ? "text-red-600" : "text-blue-600"}/>,
      Receipt: <Icon name="receiptIcon" size={8} className="text-green-600" />,
      Refund: <Icon name="refundIcon" size={6}  className="text-orange-600" />,
      Transfer: <Icon name="transferIcon" size={6} className="text-purple-600" />
    };

    return iconMap[transactionType] || null;
  };
  return (
    <div className="">
      {/* <div className="overflow-hidden bg-white pt-4">
        <div>
          <h2 className="text-indigo-600 ml-2 text-lg font-semibold">Account Summary</h2>
          <div className="my-4 ml-2 text-sm text-gray-400 space-y-3">

            <p>
              {financialSummary?.totalStudentInvoiced &&
                financialSummary?.totalStudentInvoiced !== "$0.00" && (
                  <div className="flex gap-1">
                    <Icon name="invoiceIcon" size={6}  className={"text-blue-600"}/>
                    Invoiced <b>{financialSummary?.totalStudentInvoiced}</b>
                  </div>
                )}

              {financialSummary?.totalStudentCancelledInvoiced &&
                financialSummary?.totalStudentCancelledInvoiced !== "$0.00" && (
                  <div className="flex mt-2">
                    <Icon name="invoiceIcon" size={6}  className={"text-red-600"}/>&nbsp; Invoiced Cancelled{" "}&nbsp;
                    <b>{financialSummary?.totalStudentCancelledInvoiced}</b>
                  </div>
                )}
            </p>
            
            {financialSummary?.overDueAmount &&
              financialSummary?.overDueAmount !== "$0.00" && (
                <p className="flex">
                  <AlertTriangle className="w-5 h-5 text-red-600" /> &nbsp;
                  Overdue{" "} &nbsp;
                  <b style={{ color: "#ef4444" }}>
                    {financialSummary?.overDueAmount}
                  </b>
                  {financialSummary?.lastDueDate &&
                    financialSummary?.lastDueDate?.trim() !== "" && (
                      <span>
                        {" "} &nbsp;
                        since <b>{financialSummary?.lastDueDate}</b>
                      </span>
                    )}
                </p>
              )}

            {financialSummary?.totalStudentReceipted &&
              financialSummary?.totalStudentReceipted !== "$0.00" && (
                <p className="flex">
                  <Icon name="receiptIcon" size={6} className="text-green-600" />
                  Receipted &nbsp; <b>{financialSummary?.totalStudentReceipted}</b>
                  {financialSummary?.lastReceiptAmount &&
                    financialSummary?.lastReceiptAmount !== "$0.00" && (
                      <span>
                        , last receipt{" "}
                        <b>{financialSummary?.lastReceiptAmount}</b>
                      </span>
                    )}
                  {financialSummary?.lastReceiptDate &&
                    financialSummary?.lastReceiptDate?.trim() !== "" && (
                      <span>
                        {" "}&nbsp;
                        since <b>{financialSummary?.lastReceiptDate}</b>
                      </span>
                    )}
                </p>
              )}

            {financialSummary?.totalBalanceOwing &&
              financialSummary?.totalBalanceOwing !== "$0.00" && (
                <p className="flex">
                  <DollarSign className="w-5 h-5 text-orange-600" /> &nbsp;
                  Balance owing &nbsp; <b>{financialSummary?.totalBalanceOwing}</b>
                  {financialSummary?.nextInvoiceDueAmount &&
                    financialSummary?.nextInvoiceDueAmount !== "$0.00" && (
                      <span>
                        , next invoice due{" "}
                        <b>{financialSummary?.nextInvoiceDueAmount}</b>
                      </span>
                    )}
                  {financialSummary?.nextInvoiceDueDate &&
                    financialSummary?.nextInvoiceDueDate?.trim() !== "" && (
                      <span>
                        {" "}&nbsp;
                        since <b>{financialSummary?.nextInvoiceDueDate}</b>
                      </span>
                    )}
                </p>
              )}
          </div>
        </div>
      </div> */}
      <AccountSummary financialSummary={financialSummary} loadingSummary={loadingSummary}/>
      <div className="flex flex-wrap items-center gap-2 mb-3">
        {filters.map((f) => {
          const selected = activeFilter === f.key;
          return (
            <button
              key={f.key}
              type="button"
              onClick={() => setActiveFilter(f.key)}
              className={[
                "px-3 py-1.5 rounded-full text-sm font-medium border transition",
                selected
                  ? "bg-blue-600 text-white border-blue-500"
                  : "bg-white text-gray-700 border-gray-200 hover:bg-blue-100 hover:text-blue-600",
              ].join(" ")}
            >
              {f.label}
            </button>
          );
        })}
      </div>

      {
        loadingTransactions ? ( <TableSkeleton />) : (<div className="">
        <div className="overflow-x-auto overflow-y-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-gray-50">
              <tr>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Description</th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Date</th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-right">Debit</th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-right">Credit</th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-right">Balance</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {filteredTransactions?.length ? (
                filteredTransactions.map((item) => (
                  <tr
                    className="even:bg-gray-50 hover:bg-gray-100 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
                    key={item.transactionId}
                  >
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                      <div className="flex items-center">
                        <div>{getTransactionIcon(item.transactionType, item.transactionNo)}</div>

                        <div className="ml-3 text-gray-900">
                          <div className="text-sm text-semibold text-blue-950">
                            <span className={item.transactionNo?.startsWith("-") ? "text-red-500" : ""}>{item.transactionType + "# " + item.transactionNo + " "}</span>

                            {renderStatus(
                              item.cancelled,
                              item.isOverDue,
                              item.transactionType,
                              item.isPaid,
                              item.transactionNo
                            )}
                          </div>

                          <div className="text-sm text-gray-500">
                            {"created on " + item.createDate}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm">
                      <div>
                        <div className="text-sm text-gray-900">
                          {item.transactionType + " Date: " + item.transactionDate}
                        </div>
                        <div className="text-sm text-gray-500">
                          {/* hide the due date in the case of Refund and Receipt */}
                          {item.dueDate & item.Transaction !== "Refund" && item.Transaction !== "Receipt" ? <p>Due Date: {item.dueDate}</p> : ""}
                          {renderDue(item) ? <p>{renderDue(item)}</p> : null}
                        </div>
                      </div>
                    </td>

                    <td className="whitespace-nowrap px-3 py-4 text-sm text-right">
                      {removeDecimalIfZero(item.debit)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-right">
                      {removeDecimalIfZero(item.credit)}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-right">
                      {removeDecimalIfZero(item.balance)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="py-10 text-center text-sm text-gray-500">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>)
      }
    </div>
  );
};

export default ProgramFee;


const TableSkeleton = () => {
  return (
    <div className="overflow-x-auto overflow-y-hidden shadow ring-1 ring-black ring-opacity-5 rounded-lg">
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Description</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Date</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Debit</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Credit</th>
            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Balance</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="animate-pulse">
              <td className="whitespace-nowrap py-4 pl-4 pr-3 sm:pl-6">
                <div className="flex items-center">
                  <div className="h-10 w-10 rounded-full bg-gray-200"></div>
                  <div className="ml-3 space-y-2">
                    <div className="h-4 w-48 bg-gray-200 rounded"></div>
                    <div className="h-3 w-32 bg-gray-200 rounded"></div>
                  </div>
                </div>
              </td>
              <td className="whitespace-nowrap px-3 py-4">
                <div className="space-y-2">
                  <div className="h-4 w-40 bg-gray-200 rounded"></div>
                  <div className="h-3 w-28 bg-gray-200 rounded"></div>
                </div>
              </td>
              <td className="whitespace-nowrap px-3 py-4">
                <div className="h-4 w-20 bg-gray-200 rounded"></div>
              </td>
              <td className="whitespace-nowrap px-3 py-4">
                <div className="h-4 w-20 bg-gray-200 rounded"></div>
              </td>
              <td className="whitespace-nowrap px-3 py-4">
                <div className="h-4 w-20 bg-gray-200 rounded"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
